import { Directive, ElementRef, OnInit } from '@angular/core';
import { ProfileManagerService } from '@app/custom-shared/services/profile-manager.service';

@Directive({
    selector: '[ifMasterClient]'
})
export class IfMasterClientDirective implements OnInit {
    constructor(private el: ElementRef, private profileService: ProfileManagerService) { }
    ngOnInit() {
        if (!this.profileService.isMasterClient()) this.el.nativeElement.style.display = 'none';
    }
}